import pdpStateManager from '@src/quince-site-common/src/redux/globalStateManager/PDPStateManager'

import { TELEMETRY_EVENT_NAMES } from '../telemetry-events.constants'
import { TelemetryIntegration } from '../telemetry-events.types'

import { getColorwayId } from './provider-utils/stylitics-utils'

const PLACEMENT = 'main'
export const STYLITICS_CLIENT = 'quince'
export const Stylitics: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    featureGateName: 'ssr_telemetry_stylitics',
  },
  initialize: async () => {
    try {
      /* eslint-disable import/no-unresolved, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      const StyliticsInsights = window.StyliticsInsights
      if (!StyliticsInsights?.create) {
        return
      }
      const productId = pdpStateManager.getProductIdFromRedux()
      const selectedColor = pdpStateManager.getSelectedOptions().find(option => option.name === 'Color')?.value
      const colorwayId = getColorwayId(productId?.toString(), selectedColor)
      /* eslint-enable import/no-unresolved, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-ts-comment */
      const insights = await StyliticsInsights.create({
        client: STYLITICS_CLIENT,
        itemId: colorwayId,
      })
      window.StyliticsInsights = insights as typeof window.StyliticsInsights
    } catch (err) {
      console.error('Failed to init Stylitics Insights', err)
    }
  },
  events: {
    [TELEMETRY_EVENT_NAMES.ADD_TO_CART](properties) {
      const productId = properties.productId
      const selectedColor = properties.productProperties?.color

      const colorwayId = getColorwayId(productId, selectedColor)
      const price = properties.price
      window.StyliticsInsights?.trackAddItemToCart?.({
        itemId: colorwayId,
        placement: PLACEMENT,
        price: Number(price),
        quantity: properties.quantity,
      })
    },
    [TELEMETRY_EVENT_NAMES.STYLITICS_ITEM_VIEW](properties) {
      const { itemObject, itemImageType, position } = properties
      window.StyliticsInsights?.trackItemView?.({
        item: itemObject,
        itemImageType,
        position,
      })
    },
    [TELEMETRY_EVENT_NAMES.STYLITICS_ITEM_CLICK](properties) {
      const { itemObject, placement, position } = properties
      window.StyliticsInsights?.trackItemClick?.({
        item: itemObject,
        placement,
        position,
      })
    },
  },
}
